var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0F5EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 7.25H12.25C11.7527 7.25 11.2758 7.44754 10.9242 7.79917C10.5725 8.15081 10.375 8.62772 10.375 9.125V22.875C10.375 23.3723 10.5725 23.8492 10.9242 24.2008C11.2758 24.5525 11.7527 24.75 12.25 24.75H19.75C20.2473 24.75 20.7242 24.5525 21.0758 24.2008C21.4275 23.8492 21.625 23.3723 21.625 22.875V9.125C21.625 8.62772 21.4275 8.15081 21.0758 7.79917C20.7242 7.44754 20.2473 7.25 19.75 7.25ZM20.375 22.875C20.375 23.0408 20.3092 23.1997 20.1919 23.3169C20.0747 23.4342 19.9158 23.5 19.75 23.5H12.25C12.0842 23.5 11.9253 23.4342 11.8081 23.3169C11.6908 23.1997 11.625 23.0408 11.625 22.875V9.125C11.625 8.95924 11.6908 8.80027 11.8081 8.68306C11.9253 8.56585 12.0842 8.5 12.25 8.5H19.75C19.9158 8.5 20.0747 8.56585 20.1919 8.68306C20.3092 8.80027 20.375 8.95924 20.375 9.125V22.875ZM16.9375 10.6875C16.9375 10.8729 16.8825 11.0542 16.7795 11.2083C16.6765 11.3625 16.5301 11.4827 16.3588 11.5536C16.1875 11.6246 15.999 11.6432 15.8171 11.607C15.6352 11.5708 15.4682 11.4815 15.3371 11.3504C15.206 11.2193 15.1167 11.0523 15.0805 10.8704C15.0443 10.6885 15.0629 10.5 15.1339 10.3287C15.2048 10.1574 15.325 10.011 15.4792 9.908C15.6333 9.80498 15.8146 9.75 16 9.75C16.2486 9.75 16.4871 9.84877 16.6629 10.0246C16.8387 10.2004 16.9375 10.4389 16.9375 10.6875Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4adbd0ed7d7b8d9bcee04771883a6ef7.svg";
export { ForwardRef as ReactComponent };